@if (replyType == replyTypeEnum.Approval) {
	<div class="approval">
		@if (!approval) {
			<label class="status">{{ 'questionnaire.reply-placeholder' | translate }}</label>
		}
		@else {
			@if (approval.approvalStatus == approvalStatusEnum.Approved) {
				<label class="status approved"><span class="status-icon fas fa-check"></span> {{ 'general.approved' | translate }}</label>
			}
			@if (approval.approvalStatus == approvalStatusEnum.Rejected) {
				<label class="status rejected"><span class="status-icon fas fa-times"></span> {{ 'general.rejected' | translate }}</label>
				<div class="text-block" [formattedContent]="approval.comment"></div>
			}
		}
	</div>
}
@else {
	<div class="text-block" [formattedContent]="formattedReply" [isHtmlContent]="replyType == replyTypeEnum.Editor"></div>
}
